// Authentification
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'REGISTER_FAILURE';

export const LOGOUT = 'LOGOUT';

export const VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST';
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
export const VERIFY_EMAIL_FAILURE = 'VERIFY_EMAIL_FAILURE';

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

export const AUTH_CHECK_REQUEST = 'AUTH_CHECK_REQUEST';
export const AUTH_CHECK_SUCCESS = 'AUTH_CHECK_SUCCESS';
export const AUTH_CHECK_FAILURE = 'AUTH_CHECK_FAILURE';

export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';

export const FETCH_EMAIL_NOTIFICATIONS_REQUEST = 'FETCH_EMAIL_NOTIFICATIONS_REQUEST';
export const FETCH_EMAIL_NOTIFICATIONS_SUCCESS = 'FETCH_EMAIL_NOTIFICATIONS_SUCCESS';
export const FETCH_EMAIL_NOTIFICATIONS_FAILURE = 'FETCH_EMAIL_NOTIFICATIONS_FAILURE';

export const UPDATE_EMAIL_NOTIFICATIONS_REQUEST = 'UPDATE_EMAIL_NOTIFICATIONS_REQUEST';
export const UPDATE_EMAIL_NOTIFICATIONS_SUCCESS = 'UPDATE_EMAIL_NOTIFICATIONS_SUCCESS';
export const UPDATE_EMAIL_NOTIFICATIONS_FAILURE = 'UPDATE_EMAIL_NOTIFICATIONS_FAILURE';

export const REGISTER_PENDING_VERIFICATION = 'REGISTER_PENDING_VERIFICATION';

export const FETCH_VACATIONS_REQUEST = 'FETCH_VACATIONS_REQUEST';
export const FETCH_VACATIONS_SUCCESS = 'FETCH_VACATIONS_SUCCESS';
export const FETCH_VACATIONS_FAILURE = 'FETCH_VACATIONS_FAILURE';

export const CREATE_VACATION_REQUEST = 'CREATE_VACATION_REQUEST';
export const CREATE_VACATION_SUCCESS = 'CREATE_VACATION_SUCCESS';
export const CREATE_VACATION_FAILURE = 'CREATE_VACATION_FAILURE';

export const UPDATE_VACATION_REQUEST = 'UPDATE_VACATION_REQUEST';
export const UPDATE_VACATION_SUCCESS = 'UPDATE_VACATION_SUCCESS';
export const UPDATE_VACATION_FAILURE = 'UPDATE_VACATION_FAILURE';

export const DELETE_VACATION_REQUEST = 'DELETE_VACATION_REQUEST';
export const DELETE_VACATION_SUCCESS = 'DELETE_VACATION_SUCCESS';
export const DELETE_VACATION_FAILURE = 'DELETE_VACATION_FAILURE';